import React, { useState, useEffect } from "react";
import ReportTable from "../../components/ReportTable";
import DropdownFilter from "../../components/DropdownFilter";
import DateFilter from "../../components/Date";
import Totals from "../../components/Totals";
import SearchableDropdown from "../../components/SearchableDropdown";
import callApi from "../../services/api/apiClient";
import { useSelector } from "react-redux";
import { saleReportSlice } from "../../helper/customSlice";
import LoadingComponent from "../../components/loading/LoadingComponent";
import { dispatchStore } from "../../lib/dispatchStore";
import moment from "moment/moment";

const Layout = () => {
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
  const [dateError, setDateError] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [header_data, setHeader_data] = useState(null);
  const [noDataMessage, setNoDataMessage] = useState("");

  const [userGroups, setUserGroups] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [customers, setCustomers] = useState([]);

  const [selectedUsergroup, setSelectedUsergroup] = useState(null);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [selectedSession, setSelectedSession] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [searchSession, setSearchSession] = useState("");
  const [searchCustomer, setSearchCustomer] = useState("");

  const ordersPerPage = 10;

  const Listpage = useSelector((state) => state?.saleReportSlice?.Listpage);

  const TotalPage = useSelector((state) => state?.saleReportSlice?.TotalPage);

  const reachEnd = useSelector((state) => state?.saleReportSlice?.reachEnd);

  const saleReportList = useSelector((state) => state?.saleReportSlice?.list);

  const userGroup = useSelector((state) => state?.user?.getUserGroup?.data);
  console.log(userGroup, "userGroup");

  const userProfile = useSelector((state) => state?.user?.profile?.data);
  console.log(userProfile, "userProfile");

  const mainUserGroup = userProfile?.user_group?.is_main_group === true;
  // console.log(mainUserGroup, "mainUserGroup");

  const filteredUserGroup = mainUserGroup
    ? userGroup
    : userGroup?.filter((group) => group.id === userProfile?.user_group?.id);
  // console.log(filteredUserGroup, "filteredUserGroup");

  const columns = [
    { headerName: "Sale Order No", field: "sale_order" },
    { headerName: "Total", field: "total" },
    { headerName: "Gross profit", field: "gross" },
    { headerName: "Customer", field: "customer" },
    { headerName: "Order DateTime", field: "order_datetime" },
    { headerName: "Order Status", field: "order_status" },
    { headerName: "Invoice Status", field: "invoice_status" },
    { headerName: "Checked", field: "checked" },
    { headerName: "Session", field: "live_sale_session" },
    { headerName: "Livesale Room", field: "live_sale_room" },
    { headerName: "Sale Person", field: "sale_person" },
  ];

  const childColumns = [
    { headerName: "Product", field: "product" },
    { headerName: "Livesale Code", field: "livesale_code" },
    { headerName: "Livesale Price", field: "livesale_price" },
    { headerName: "Quantity", field: "quantity" },
    { headerName: "Cost", field: "cost" },
    { headerName: "Gross profit", field: "gross" },
    { headerName: "FOC", field: "foc" },
  ];

  const state = [
    { id: 1, name: "Draft" },
    { id: 2, name: "Sale" },
  ];

  const validateDates = (from, to) => {
    if (from && to && moment(from).isAfter(to)) {
      setDateError("From Date cannot be later than To Date");
      return false;
    }
    setDateError("");
    return true;
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    if (validateDates(date, toDate)) {
      getsaleReport(); // Fetch report if dates are valid
    }
  };

  const handleToDateChange = (date) => {
    setToDate(date);
    if (validateDates(fromDate, date)) {
      getsaleReport();
    }
  };

  useEffect(() => {
    fetchUserGroups();
  }, []);

  useEffect(() => {
    getCustomers(selectedUsergroup);
  }, [searchCustomer, selectedUsergroup]);

  useEffect(() => {
    getLiveSaleSessions(selectedRoom);
  }, [searchSession, selectedRoom]);

  // useEffect(() => {
  //   getUserProfile();
  // }, []);

  // const getUserProfile = async () => {
  //   const response = await callApi("user/profile")
  //     .loadingGroup("user-profile")
  //     .executeDispatch();
  //   console.log(response?.data, "user profile");
  //   // setHeader_data(response?.data || []);
  // };

  const fetchUserGroups = async () => {
    const response = await callApi("user/getUserGroup")
      .loadingGroup("user")
      .executeDispatch();

    const groups = response?.data || [];
    setUserGroups(groups);
  };

  const fetchLiveSaleRooms = async (userGroupId) => {
    await callApi(`liveSale/roomList`)
      .withParam({ user_group_id: userGroupId })
      .loadingGroup("livesale")
      .execute()
      .then((response) => {
        setRooms(response || []);
      });
  };
  const getLiveSaleSessions = async (RoomId) => {
    if (!RoomId) {
      setSessions([]);
      return;
    }

    try {
      await callApi("liveSale/liveSaleSessionList")
        .withParam({
          room_id: RoomId,
          user_group_id: selectedUsergroup,
          per_page: 50,
          keywords: searchSession,
        })
        .loadingGroup("livesalesession")
        .execute()
        .then((response) => {
          setSessions(response?.data || []);
        });
    } catch (error) {
      console.error("Error fetching sessions:", error);
      setSessions([]);
    }
  };

  const getCustomers = async (userGroupId) => {
    if (!userGroupId) {
      setCustomers([]);
      return;
    }

    try {
      await callApi("customer/customerList")
        .withParam({
          user_group_id: userGroupId,
          per_page: 50,
          keywords: searchCustomer,
        }) // Use the provided userGroupId
        .loadingGroup("customer")
        .execute()
        .then((response) => {
          setCustomers(response?.data || []);
        });
    } catch (error) {
      console.error("Error fetching customers:", error);
      setCustomers([]);
    }
  };

  useEffect(() => {
    if (validateDates(fromDate, toDate)) {
      getsaleReport();
    }
  }, [
    Listpage,
    fromDate,
    toDate,
    selectedStatus,
    selectedUsergroup,
    selectedRoom,
    selectedSession,
    selectedCustomer,
  ]);

  // useEffect(() => {
  //   getsaleReport();
  // }, []);

  const getsaleReport = async () => {
    let params = {
      page_no: Listpage,
      per_page: 10,
    };

    if (fromDate) {
      params.date_from = moment(fromDate).format("YYYY-MM-DD");
    }
    if (toDate) {
      params.date_to = moment(toDate).format("YYYY-MM-DD");
    }

    if (selectedStatus) {
      params.state = selectedStatus;
    }
    if (selectedUsergroup) {
      params.user_group_id = selectedUsergroup;
    }

    if (selectedRoom) {
      params.roomID = selectedRoom;
    }
    if (selectedSession) {
      params.sessionID = selectedSession?.id;
    }
    if (selectedCustomer) {
      params.customer_id = selectedCustomer?.id;
    }

    await callApi("report/saleReport")
      .withParam(params)
      .loadingGroup("report")
      .execute()
      .then((res) => {
        console.log(res, "response sale report");
        if (res?.order_data?.data?.length === 0) {
          setNoDataMessage("No data found for the selected filters.");
        } else {
          setNoDataMessage("");
        }

        setHeader_data(res);
        console.log(res, "header_data");
        dispatchStore(
          saleReportSlice.actions.setSaleReportList(res?.order_data)
        );
      });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="container px-4">
      <div className="max-h-screen w-fit">
        {/* Center Heading */}
        <h1 className="text-xl font-bold mb-6 text-center mt-4">Sale Report</h1>

        {/* Filters Section */}
        <div className="flex  justify-start space-x-4 text-sm mb-4">
          <div className="flex flex-col items-start">
            <DateFilter
              fromDate={fromDate}
              toDate={toDate}
              setFromDate={handleFromDateChange}
              setToDate={handleToDateChange}
            />
            {dateError && <p className="text-red-500 text-sm">{dateError}</p>}
          </div>
        </div>
        <div className="flex items-center justify-start space-x-4 text-sm mb-4">
          <div className="flex flex-col">
            <label htmlFor="statusDropdown" className="text-gray-700 mb-1">
              Select Status
            </label>
            <DropdownFilter
              placeholder="All"
              dropdownItems={state}
              valueKey="name"
              onSelect={(value) => {
                setSelectedStatus(value?.name?.toLowerCase());
                dispatchStore(saleReportSlice.actions.setListpage(1));
              }}
            />
          </div>
          {/* User Group Filter */}
          <div className="flex flex-col">
            <label htmlFor="usergroupDropdown" className="text-gray-700 mb-1">
              Select Usergroup
            </label>
            <DropdownFilter
              placeholder="All"
              dropdownItems={filteredUserGroup}
              valueKey="id"
              onSelect={async (value) => {
                const userGroupId = value?.id;
                setSelectedUsergroup(userGroupId);
                setSelectedRoom(null);
                setSelectedSession(null);
                setSelectedCustomer(null);
                setRooms([]);
                setSessions([]);
                setCustomers([]);

                if (userGroupId) {
                  await fetchLiveSaleRooms(userGroupId);
                  await getCustomers(userGroupId);
                }

                dispatchStore(saleReportSlice.actions.setListpage(1));
              }}
            />
          </div>
          {/* Room Filter */}
          <div className="flex flex-col">
            <label htmlFor="roomDropdown" className="text-gray-700 mb-1">
              Select Room
            </label>
            <DropdownFilter
              placeholder="All"
              dropdownItems={rooms}
              onSelect={async (value) => {
                const RoomId = value?.id;
                setSelectedRoom(RoomId);
                setSelectedSession(null);
                setSessions([]);

                if (RoomId) {
                  await getLiveSaleSessions(RoomId);
                }

                dispatchStore(saleReportSlice.actions.setListpage(1));
              }}
            />
          </div>
          {/* Session Filter */}
          <div className="flex flex-col ">
            <label htmlFor="sessionDropdown" className="text-gray-700 mb-1">
              Select Session
            </label>
            <SearchableDropdown
              key={selectedUsergroup}
              options={sessions}
              label="session"
              selectedVal={selectedSession?.name ? selectedSession?.name : ""}
              handleChange={setSelectedSession}
              onSelect={(value) => {
                setSelectedSession(value);
                dispatchStore(saleReportSlice.actions.setListpage(1));
              }}
              placeholder="All Sessions"
              searchValue={searchSession}
              setSearchValue={setSearchSession}
            />
          </div>

          {/* Customer Filter */}
          <div className="flex flex-col space-x-0">
            <label htmlFor="customerDropdown" className="text-gray-700 mb-1">
              Select Customer
            </label>
            <SearchableDropdown
              key={selectedUsergroup}
              options={customers}
              label="customer"
              selectedVal={selectedCustomer?.name}
              handleChange={setSelectedCustomer}
              onSelect={(value) => {
                setSelectedCustomer(value);
                dispatchStore(saleReportSlice.actions.setListpage(1));
                // if (!value || searchCustomer?.length > 0) {
                //   getCustomers(selectedUsergroup);
                // }
              }}
              placeholder="All customers"
              searchValue={searchCustomer}
              setSearchValue={setSearchCustomer}
            />
          </div>
        </div>

        {/* Totals */}
        <Totals orders={header_data} />

        {/* Table Section */}
        <div className="overflow-x-auto w-full mt-4">
          <LoadingComponent loadingGroup="report">
            {
              noDataMessage ? (
                <p className="text-gray-600 text-center">{noDataMessage}</p>
              ) : (
                saleReportList?.length > 0 && (
                  <ReportTable
                    columns={columns}
                    childColumns={childColumns}
                    data={saleReportList}
                    currentPage={currentPage}
                    ordersPerPage={ordersPerPage}
                    onPageChange={handlePageChange}
                    TotalPage={TotalPage}
                    Listpage={Listpage}
                    reachEnd={reachEnd}
                  />
                )
              )
              // : (
              //   <p className="text-gray-600 text-center">Loading...</p>
              // )
            }
          </LoadingComponent>
        </div>
      </div>
    </div>
  );
};

export default Layout;
